import FlashLib from "flashlib";
import BasePreloaderView from "Engine/base/preloader/BasePreloaderView";
import * as PIXI from "pixi.js";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import ScaleManager from "Engine/ScaleManager";
import EntryPoint from "Engine/EntryPoint";

export default class PreloaderView extends BasePreloaderView {

    constructor(gameSizeConfig) {
        super(gameSizeConfig);

        this.interactive = true;
    }

    addListeners() {
        super.addListeners();
        GlobalDispatcher.add('scaleManager:resize', this.onGameResized, this);
    }

    onGameResized(event) {
        if (this.preloader && EntryPoint.mobile) {
            let scale = Math.max(event.params.canvasWidth, event.params.canvasHeight) / 1920;
            this.preloaderBackground.scale.set(scale, scale);
            this.preloaderBackground.y = event.params.canvasHeight / 2;
            //this.preloaderBackground.y = event.params.canvasHeight / 2;
            //this.preloaderBackground.y -= this.preloaderBackground.height / 2;
            //this.preloaderBackground.x = (Math.max(event.params.canvasWidth, this.preloaderBackground.width) / Math.min(event.params.canvasWidth, this.preloaderBackground.width)) / 2;

            this.preloaderLogo.y = 300; //(event.params.canvasHeight - this.preloaderLogo.height) / 2 - 400;
            this.progressBar.y = (event.params.canvasHeight - this.progressBar.height) / 2 + 200;

            let l1 = this.preloader.getChildAt(3);
            let l2 = this.preloader.getChildAt(4);
            l1.y = (event.params.canvasHeight - l1.height) / 2 + 300;
            l2.y = (event.params.canvasHeight - l2.height) / 2 + 430;
        }
    }

    buildPrePreLoader() {

    }

    buildPreLoader() {
        this.removeChildren();
        this.preloader = FlashLib.createItemFromLibrary('Main', 'PreloaderFlashLib');

        this.preloaderBackground = this.preloader.getChildAt(0);
        this.progressBar = this.preloader.getChildByName('progressBar');
        this.preloaderLogo = this.preloader.getChildAt(1);

        this.addChild(this.preloader);

        this.onGameResized({params:ScaleManager.currentData});
    }

    onAllResourcesLoaded() {

    }

    onProgress(data) {
        let aaa = 100 / 9; //количество элементов прогрессбара
        let sss = data.params / aaa; //сколько элементов заполняют текущий прогресс (дробное)
        let ddd = Math.floor(sss); //сколько элементов заполняет текущий прогресс (целое)
        //let xxx = sss - ddd //какя дробная чать заполняет прогресс

        this.progressBar.update(data.params);
    }

    destroy(options) {
        GlobalDispatcher.remove('scaleManager:resize', this.onGameResized, this);
        super.destroy(options)
    }
}
